import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';

var selectedOptionInUsersTab = new Array();
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/SiteInfo/SiteInfo.html'
})

export class SiteInfoComponent implements OnInit {
    public constants: Constants;
    public siteInfoStatus: any[] = [];
    public serviceType: any[] = [];
    public Search: any = "";
    public Customer_Name: any = "";
    public siteInfo: any[] = [];
    public customerItem: any[] = [];
    public filterSiteInfoStatus: any = "";
    public filterServiceTypeStatus: any = 3;
    public filterCustomerName: any = "";
    public addSiteInfoData: any = { addSiteInfoClient: "" };
    public packageName: any[] = [];
    public isAdd: boolean = true;
    active = true;
      userDetail: any;
      
    public showLoader = false;
    public existsTeamName: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.filterSiteInfoStatus = this.constants.enumUserStatus["Active"];
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));

    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.filterServiceTypeStatus = 3;
        this.getStatus();
        this.GetSiteInfo();
        this.GetCustomer();
        this.getServiceType();
    }

    ngAfterViewInit() {
        $("#Createddate").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#Renewaldate").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        setTimeout(() => {
            $('#teammultiselect').multiselect({
                enableFiltering: false,
                includeSelectAllOption: true,
                selectAllJustVisible: false,
            });

            $('#teammultiselect option').each(function () {
                if ($(this).attr('selected') == 'selected') {
                }
            });
        }, 1000);

        $("#teammultiselect").change(function () {
            var selectOption = $(this).find(":selected");
            var selectedValues = new Array();
            selectedOptionInUsersTab = new Array();
            selectOption.each(function (e) {
                selectedValues.push($(this).val());
                selectedOptionInUsersTab.push($(this).val());
            });
            $("#teammultiselect").val(selectedValues);
            $("#usersTeamAssigned").val(selectedValues);
            var selectPanel = $("#accordion").find(".panel.panel-default");
            selectPanel.each(function (e) {
                if (selectedOptionInUsersTab.includes($(this).find(".panel-collapse.collapse").attr("id"))) {
                    $(this).removeClass("hide");
                    $(this).addClass("show");
                }
                else {
                    $(this).removeClass("show");
                    $(this).addClass("hide");
                }
            });
        });

        setTimeout(() =>
            $('.customer').selectpicker({
                style: 'btn-info',
                size: 4
            })
            , 1000);
    }

    ExportItems() {
        var fil = new filter();
        var ExportList;
        ExportList = JSON.parse(JSON.stringify(this.siteInfo));
        ExportList = fil.transform(ExportList, this.filterCustomerName);
        ExportList = fil.transform(ExportList, this.Search);
        for (var i = 0; i < ExportList.length; i++) {
            var element = ExportList[i];
            var AccessId: any = [];
            var AccessName: any = [];
            var AccessId = element.Access.split(",")
            for (var j = 0; j < AccessId.length; j++) {
                if (AccessId[j] == 0) {
                    AccessName.push("Sys Admin");
                }
                else if (AccessId[j] == 1) {
                    AccessName.push("Admin");
                }
                else if (AccessId[j] == 2) {
                    AccessName.push("Manager");
                }
                else if (AccessId[j] == 3) {
                    AccessName.push("Executive");
                }
            }
            element.Access = AccessName.join(",")
        }
        ExportToExcel(ExportList, "SiteInfo",
            ["Customer_Name", "ServiceName", "ServerTypeName", "URL", "Provider", "Packagename", "CreateDate", "RenewalDate", "StatusName", "SellingPrice", "CostPrice", "Remark", "AppUser", "ControlPanel", "Access"],
            ["Customer Name", "Service Name", "Server Type Name", "URL", "Provider", "Package Name", "Created Date", "Renewal Date", "Status", "Selling Price", "Cost Price", "Remark", "AppUser", "Control Panel", "Access"]);
    }



    public getServiceType() {
        debugger
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["ServiceType"] }).subscribe(
            data => {
                this.serviceType = data["Parameter"];
            }
        );
    }
    public getStatus() {
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.siteInfoStatus = data["Parameter"];
            }
        );
    }

    public GetSiteInfo() {
        debugger
        //this.showLoader = true;
        console.log(this.userDetail) 
        this._httpService.ajaxPost('SiteInfo/GetSiteInfoByAccess', { "ServiceId": 0, "IsActive": this.filterSiteInfoStatus, "ServerType": this.filterServiceTypeStatus, "CustomerId": 0, "RoleId" : this.userDetail.RoleId ,"loggedInUser" : this.userDetail.SiteUserId }).subscribe(
            data => {
                this.siteInfo = data["SiteInfoList"];
             //   this.showLoader = false;
            });
    }

    public GetCustomer() {
        this._httpService.ajaxPost('Customer/GetAssignedProjectCustomer', { "UserId" : this.userDetail.SiteUserId}).subscribe(
            data => {
                this.customerItem = data["Customer"];
            }
        );
    }

    public clearFilter() {
        this.Search = "";
        this.filterSiteInfoStatus = this.constants.enumUserStatus["Active"];
        this.filterCustomerName = "";
        this.filterServiceTypeStatus = "";

    }
    public CancelAddSiteInfo() {
        this.addSiteInfoData = {};
        this.newForm();
        $('#addSiteInfo').modal('hide');
        this.isAdd = true;
    }

    public AddSiteInfo() {
        let objItem: any = {};
        objItem.ServiceId = 0;
        objItem.ServiceName = this.addSiteInfoData.addServiceName;
        objItem.CustomerId = this.addSiteInfoData.Customer_Id;
        objItem.ServerType = this.addSiteInfoData.addSiteInfoServiceType;
        objItem.Provider = this.addSiteInfoData.addProvider;
        objItem.URL = this.addSiteInfoData.addURL;
        if (this.addSiteInfoData.addPackageName) {
            objItem.Packagename = this.addSiteInfoData.addPackageName;
        } else {
            objItem.Packagename = this.addSiteInfoData.addSiteInfoOR;
        }
        objItem.CreateDate = this.addSiteInfoData.SiteInfoCreatedDate;
        objItem.RenewalDate = this.addSiteInfoData.SiteInfoRenewalDate;
        objItem.Remark = this.addSiteInfoData.addSiteInfoRemark;
        objItem.AppUser = this.addSiteInfoData.addSiteInfoAppUser;
        objItem.ControlPanel = this.addSiteInfoData.addSiteInfoControlPanel;
        objItem.SellingPrice = this.addSiteInfoData.addSellingPrice;
        objItem.CostPrice = this.addSiteInfoData.addCostPrice;
        objItem.IsActive = this.addSiteInfoData.addSiteInfoIsActive;
        objItem.Access = this.addSiteInfoData.addSiteInfoAccess;
        this.addEditSiteInfo(objItem);
        $('#addSiteInfo').modal('hide');
        this.addSiteInfoData = {};
        this.isAdd = true;
    }

    addEditSiteInfo(objItem) {
        this._httpService.ajaxPost('SiteInfo/AddUpdateSiteInfo', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|')
                ;
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                }
                this.GetSiteInfo();
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/SiteInfo/SiteInfo.component.ts
 **/